import classes from './Form.module.scss';

type FormProps = {
  children: React.ReactNode;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
} & React.ComponentPropsWithoutRef<'form'>;

export const Form = ({ children, ...props }: FormProps) => {
  return (
    <form className={classes.form} {...props}>
      {children}
    </form>
  );
};
